import React from 'react';
import UserList from './UserList';

const UsersAndTechnicians = () => {
  return <UserList />;
};

export default UsersAndTechnicians;
